"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuCalendar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ContextItem_1 = require("./ContextItem");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
/**
 * A set of context options for a selected event.
 */
var ContextMenuCalendar = function (_a) {
    var onSelect = _a.onSelect;
    var handleSelection = function (selection, params) { return function () {
        if (onSelect) {
            onSelect(selection, params);
        }
    }; };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: {
            display: "flex",
            flexDirection: "column",
        } }, { children: [(0, jsx_runtime_1.jsx)(ContextItem_1.ContextItem, { name: "New Group", icon: pro_regular_svg_icons_1.faFolderPlus, onClick: handleSelection("createGroup") }, void 0), (0, jsx_runtime_1.jsx)(ContextItem_1.ContextItem, { name: "Move to Group", icon: pro_regular_svg_icons_1.faArrowsAlt, onClick: handleSelection("sendToGroup") }, void 0), (0, jsx_runtime_1.jsx)(ContextItem_1.ContextItem, { name: "Edit Calendar", icon: pro_regular_svg_icons_1.faEdit, onClick: handleSelection("editCalendar") }, void 0)] }), void 0));
};
exports.ContextMenuCalendar = ContextMenuCalendar;
